/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { LinkProps } from "./LinkProps";
import "./Link.css"; // Assuming you'll define your hover styles in this CSS file.

const Link: React.FC<LinkProps> = ({
  children,
  color,
  underline,
  className,
  onClick,
  to,
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick(e);
    }
  };

  const styledChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      // Type assertion to ensure 'child' has 'style' prop
      const childWithProps = child as ReactElement<any>;
      return React.cloneElement(
        childWithProps,
        {
          style: {
            ...(childWithProps.props?.style || {}),
            textDecoration: underline ? "underline" : "none",
          },
        }
      );
    }
    return child;
  });

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions
    <a
      // eslint-disable-next-line
      style={{ color, textDecoration: underline ? "underline" : "" }}
      className={`link ${className ?? ""}`}
      onClick={handleClick}
    >
      {styledChildren}
    </a>
  );
};

export default Link;
